const subscriptionParser = (response: any) => {
  const subscriptions = response?.subscriptions?.map((item: any) => {
    return {
      id: item?.transaction?.id ?? '',
      status: item?.transaction?.status ?? '',
      type: item?.transaction?.standingInstruction?.type ?? 0,
      scheduledAt: item?.transaction?.standingInstruction?.scheduledAt ?? '',
      frequency: item?.transaction?.standingInstruction?.frequency ?? 0,
      scheduledEnd: item?.transaction?.standingInstruction?.scheduledEnd ?? '',
      amount: item?.transaction?.standingInstruction?.ruleAmountValue ?? '',
      customer: {
        id: item?.payer?.userId ?? '',
        name: item?.payer?.name ?? '',
        email: item?.payer?.email ?? '',
        vpa: item?.payer?.vpa ?? '',
        mobile: item?.payer?.mobile?.number
          ? `${item?.payer?.mobile?.countryCode} ${item?.payer?.mobile.number}`
          : 'NA',
        externalId: item?.payer?.externalId ?? 'NA',
      },
      createdAt: item?.transaction?.created ?? 'NA',
      updatedAt: item?.transaction?.updated ?? 'NA',
      revocable: item?.transaction?.standingInstruction?.revocable ?? false,
      ruleRecurrenceValue: item?.transaction?.standingInstruction?.ruleRecurrenceValue,
      merchantId: item?.payee?.merchantId ?? '',
      merchantName: item?.payee?.name ?? 'NA',
      merchantType: item?.payee?.type ?? 0,
      jmSubsId: item?.transaction?.standingInstruction?.uniqueMandateNumber ?? '', // check
      invoice: item?.transaction?.invoice ?? '',
      paymentMode: item?.transaction?.method?.subType?.toString() ?? 'NA',
    }
  })
  const parseData = {
    pagination: response?.configParams,
    subscriptions: subscriptions,
  }
  return parseData
}

export { subscriptionParser }
